import { useMemo } from 'react'

import type { GroupedSection } from '../types'

export const useRecommendations = ({ sections }: { sections?: GroupedSection[] }) => {
  const recommendations: GroupedSection[] = useMemo(() => {
    const filteredSections = sections?.filter(({ group }) => ['Layout', 'Shop'].includes(group))

    if (!filteredSections) return []

    const recommendedSections: GroupedSection[] = filteredSections?.map(({ group, sections }) => {
      if (group === 'Layout') {
        return {
          group,
          sections: sections.filter((section) =>
            ['hero', 'hero-video', 'image-with-text', 'video-with-text', 'links-list'].includes(
              section.sectionType,
            ),
          ),
        } satisfies GroupedSection
      }

      return {
        group,
        sections: sections.filter((section) =>
          ['featured-collection', 'featured-product', 'collections-list'].includes(
            section.sectionType,
          ),
        ),
      } satisfies GroupedSection
    })

    return recommendedSections
  }, [sections])

  return {
    recommendations,
  }
}
